// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Copyright (c) Microsoft Corporation.\r\n   Licensed under the MIT license. */\r\n\r\n/* Add custom CSS here */\r\n", ""]);
// Exports
module.exports = exports;
